module.exports = __webpack_public_path__ + "static/media/house-6.eb82d8a4.jpg";